module.exports = __webpack_public_path__ + "static/greenstar-d5b16181d02baded258d6d50dec105df.png";